import { React, useState, useEffect } from 'react';
import styled from 'styled-components';

import NewWeeklyClass from './NewWeeklyClass.js';

export default function WeeklyClassBox(props) {
  const {
    rendering,
    setRendering,
    today,
    standardDate,
    isLoading,
    setIsLoading,
    isInProgress,
    setIsInPregress,
    scheduleData,
    breakTimeData,
    canceledSchedules,
    setClickDate,
    onClickDeleteButton,
    onClickScheduleDetail,
    onClickPlusColumn
  } = props;

  const [standardDateList, setStandardDateList] = useState([]);

  // 매 주차 첫번째날 뽑기 //
  useEffect(() => {
    let newList = [];

    newList.push(standardDate.clone());

    let nextStandardDate = standardDate.clone().add(7, 'days');

    while (true) {
      if (standardDate.clone().format('MM') === nextStandardDate.clone().format('MM')) {
        newList.push(nextStandardDate.clone());

        nextStandardDate.add(7, 'days');
      }
      else break;
    }

    setStandardDateList(newList);
  }, [standardDate])

  return (
    <TopLevelWrapper>
      {
        standardDateList.map((data, index) => (
          <WeeklyWrapper key={'WeeklyDates-' + index}>
            <NewWeeklyClass
              index={index}
              rendering={rendering}
              setRendering={setRendering}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
              isInProgress={isInProgress}
              setIsInPregress={setIsInPregress}
              scheduleData={scheduleData}
              breakTimeData={breakTimeData}
              canceledSchedules={canceledSchedules}
              today={data}
              setClickDate={setClickDate}
              onClickDeleteButton={onClickDeleteButton}
              onClickScheduleDetail={onClickScheduleDetail}
              onClickPlusColumn={onClickPlusColumn} />
            {standardDateList.length !== index + 1 && <DivisionLine />}
          </WeeklyWrapper>
        ))
      }
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding-bottom: 20px;
  margin-bottom: 96px;

  width: 1020px;

  border-radius: 20px;
  box-shadow: 0px 40px 50px rgba(240, 232, 227, 0.5);
  background-color: #FFFFFF;
  
  transition: all 0.3s ease-in-out;
`;

const WeeklyWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;
`;

const DivisionLine = styled.div`
  display: flex;
  flex-direction: column;

  margin-top: 25px;

  width: 974px;
  height: 2px;

  border-radius: 4px;
  background-color: rgba(255, 139, 72, 0.5);
`;
